import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StateAdminParams } from "../types/admin/adminParams";

interface AdminsInitialStateParams {
    isLoading: boolean;
    getAllAdmins: StateAdminParams[];
    searchAdmin: StateAdminParams[];
    currentPage: number;
    numberOfPages: number;
    totalNumber: number;
    singleAdmin: StateAdminParams | null;
    updateAdmin: StateAdminParams[] | null;
    deleteAdmin: StateAdminParams[] | null;
}

const initialState: AdminsInitialStateParams = {
    isLoading: true,
    getAllAdmins: [],
    searchAdmin: [],
    currentPage: 1,
    numberOfPages: 0,
    totalNumber: 0,
    singleAdmin: null,
    updateAdmin: null,
    deleteAdmin: null,
}

const adminsSlice = createSlice({
    name: 'ADMINS',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading     = true;
        },
        endLoading: (state) => {
            state.isLoading     = false;
        },
        setAdmins: (state, action: PayloadAction<{
            data: StateAdminParams[];
            currentPage: number;
            numberOfPages: number;
            totalNumber: number;
        }>) => {
            state.getAllAdmins         = action.payload.data;
            state.currentPage         = action.payload.currentPage;
            state.numberOfPages       = action.payload.numberOfPages;
            state.totalNumber         = action.payload.totalNumber;
        },
        setSingleAdmin: (state, action: PayloadAction<StateAdminParams>) => {
            state.singleAdmin          = action.payload;
        },
        setAdminsSearch: (state, action: PayloadAction<{
            data: StateAdminParams[];
            currentPage: number;
            numberOfPages: number;
            totalNumber: number;
        }>) => {
            state.searchAdmin          = action.payload.data;
            state.currentPage         = action.payload.currentPage
            state.numberOfPages       = action.payload.numberOfPages
            state.totalNumber         = action.payload.totalNumber
        },
        setUpdateAdmin: (state, action: PayloadAction<StateAdminParams>) => {
            state.updateAdmin          = state.getAllAdmins.map((result) =>
                result._id === action.payload._id ? action.payload : result
            );
        },
        setDeleteAdmin: (state, action: PayloadAction<string>) => {
            state.deleteAdmin = state.getAllAdmins.filter((result) => result._id !== action.payload);
        }
    }
});

export const { startLoading, endLoading, setAdmins, setSingleAdmin, setAdminsSearch, setUpdateAdmin, setDeleteAdmin } = adminsSlice.actions
export default adminsSlice.reducer
